import { Link } from 'react-router-dom'

const C = { primary: '#206bc4', dark: '#0f172a', gray50: '#f8fafc', gray200: '#e2e8f0', gray400: '#94a3b8', gray500: '#64748b', gray600: '#475569', white: '#fff' }

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 28 }}>
      <h2 style={{ fontSize: 18, fontWeight: 700, color: C.dark, marginBottom: 8 }}>{title}</h2>
      <div style={{ fontSize: 14, color: C.gray600, lineHeight: 1.8 }}>{children}</div>
    </div>
  )
}

export default function PrivacyPage() {
  return (
    <div style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif", minHeight: '100vh', background: C.gray50 }}>
      <nav style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 5%', maxWidth: 1000, margin: '0 auto' }}>
        <Link to="/landing" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
          <div style={{ width: 28, height: 28, borderRadius: 6, background: C.primary, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 900, fontSize: 14 }}>L</div>
          <span style={{ fontWeight: 800, fontSize: 18, color: C.dark }}>Leadiox</span>
        </Link>
        <Link to="/login" style={{ fontSize: 14, color: C.gray500, textDecoration: 'none' }}>Sign In</Link>
      </nav>

      <div style={{ maxWidth: 720, margin: '0 auto', padding: '20px 5% 60px' }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, color: C.dark, marginBottom: 4 }}>Privacy Policy</h1>
        <p style={{ fontSize: 13, color: C.gray400, marginBottom: 32 }}>Last updated: February 2026</p>

        <Section title="1. Introduction">
          <p>Delvios LLC ("we," "us," "our") operates Leadiox, a hotel sales CRM platform. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our Service.</p>
        </Section>

        <Section title="2. Information We Collect">
          <p><strong>Account Information:</strong> When you register, we collect your name, email address, phone number, hotel name, and role/title. This is necessary to provide the Service.</p>
          <p style={{ marginTop: 8 }}><strong>Business Data:</strong> You may enter leads, contacts, events, proposals, contracts, invoices, and other business data into the Service. This data belongs to you.</p>
          <p style={{ marginTop: 8 }}><strong>Usage Data:</strong> We automatically collect information about how you use the Service, including pages visited, features used, and timestamps. This helps us improve the product.</p>
          <p style={{ marginTop: 8 }}><strong>Payment Data:</strong> Payment processing is handled by LemonSqueezy. We do not store your credit card number or banking information directly. We receive only transaction confirmations and subscription status.</p>
        </Section>

        <Section title="3. How We Use Your Information">
          <p>We use your information to: (a) provide, maintain, and improve the Service; (b) process payments and manage subscriptions; (c) send service-related communications such as account confirmations and billing notices; (d) respond to support requests; (e) monitor usage patterns to improve performance and features; (f) protect against fraud and unauthorized access.</p>
          <p style={{ marginTop: 8 }}>We do not use your information for advertising, profiling, or any purpose unrelated to providing the Service.</p>
        </Section>

        <Section title="4. Data Sharing">
          <p>We do not sell, rent, or trade your personal information. We may share data with:</p>
          <p style={{ marginTop: 8 }}><strong>Service Providers:</strong> We use third-party services for hosting (cloud infrastructure), payment processing (LemonSqueezy), and email delivery. These providers only access data as necessary to perform their services and are bound by confidentiality obligations.</p>
          <p style={{ marginTop: 8 }}><strong>Legal Requirements:</strong> We may disclose information if required by law, court order, or government request, or to protect the rights, safety, or property of Delvios LLC or others.</p>
          <p style={{ marginTop: 8 }}><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction. We will notify you of any such change.</p>
        </Section>

        <Section title="5. Data Security">
          <p>We implement industry-standard security measures to protect your data, including encryption in transit (TLS/SSL), encryption at rest, access controls, and regular security reviews. However, no method of electronic transmission or storage is 100% secure, and we cannot guarantee absolute security.</p>
        </Section>

        <Section title="6. Data Retention">
          <p>We retain your data for as long as your account is active or as needed to provide the Service. When you cancel your account, we will delete your data within 30 days, except where retention is required by law or for legitimate business purposes such as fraud prevention or dispute resolution.</p>
        </Section>

        <Section title="7. Your Rights">
          <p>Depending on your jurisdiction, you may have the right to: (a) access the personal data we hold about you; (b) correct inaccurate data; (c) request deletion of your data; (d) export your data in a portable format; (e) object to certain processing of your data.</p>
          <p style={{ marginTop: 8 }}>To exercise any of these rights, contact us at <a href="mailto:privacy@leadiox.com" style={{ color: C.primary }}>privacy@leadiox.com</a>. We will respond within 30 days.</p>
        </Section>

        <Section title="8. Cookies & Tracking">
          <p>We use essential cookies to maintain your session and keep you logged in. We do not use tracking cookies, advertising cookies, or third-party analytics that track you across websites. We may use basic, privacy-respecting analytics to understand aggregate usage patterns.</p>
        </Section>

        <Section title="9. Third-Party Links">
          <p>The Service may contain links to third-party websites. We are not responsible for the privacy practices of those sites. We encourage you to review their privacy policies.</p>
        </Section>

        <Section title="10. Children's Privacy">
          <p>The Service is not intended for use by individuals under 18 years of age. We do not knowingly collect personal information from children.</p>
        </Section>

        <Section title="11. International Data Transfers">
          <p>If you access the Service from outside the United States, your data may be transferred to and processed in the United States. By using the Service, you consent to this transfer.</p>
        </Section>

        <Section title="12. Changes to This Policy">
          <p>We may update this Privacy Policy from time to time. We will notify you of material changes via email or through the Service. The "Last updated" date at the top of this page indicates when the policy was last revised.</p>
        </Section>

        <Section title="13. Contact Us">
          <p>For privacy-related questions or concerns, contact us at:<br />
          Email: <a href="mailto:privacy@leadiox.com" style={{ color: C.primary }}>privacy@leadiox.com</a><br />
          Delvios LLC, Atlanta, GA</p>
        </Section>

        <div style={{ marginTop: 40, paddingTop: 20, borderTop: `1px solid ${C.gray200}`, display: 'flex', gap: 20, fontSize: 13, color: C.gray400 }}>
          <Link to="/terms" style={{ color: C.primary, textDecoration: 'none' }}>Terms of Service</Link>
          <Link to="/landing" style={{ color: C.gray400, textDecoration: 'none' }}>Back to Home</Link>
        </div>
      </div>
    </div>
  )
}
